import { useState, useEffect } from "react";
import { ColourCircleC } from "../ui/ColourCircle";
import { CardC } from "../ui/Cards";

import { useParamsContext } from "../../contexts";

//api calls
import { useSampleEdit } from "./../../api";

// react-bootstrap
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

export default function SampleInformation({ sample }) {
  const id = sample._id;

  const [validated, setValidated] = useState(false);
  const [customId, setCustomId] = useState(sample.customId || "");
  const [isSaved, setIsSaved] = useState(!!sample.customId);
  const isCustomIdInvalid = customId.length > 15;

  useEffect(() => {
    if (isSaved) {
      setCustomId(sample.customId || "");
    }
  }, [sample.customId]);

  const { getColour, getTexture } = useParamsContext(); // getColour and getTexture are functions that are passed down as props from the context

  let colour = getColour(sample.colourId);
  let texture = sample.texture ? getTexture(sample.texture) : {};

  const { mutateAsync, isLoading: editLoading } = useSampleEdit(id);

  async function handleSave(e) {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      console.log("Form is invalid");
      e.stopPropagation();
      setValidated(true);
      return;
    }

    try {
      if (customId !== sample.customId) {
        await mutateAsync({ id, data: { customId } });
      }
      setIsSaved(customId ? true : false);
      setValidated(false);
    } catch (err) {
      console.error("Failed to save custom ID:", err);
    }
  }

  return (
    <div className=' my-2 full-height'>
      <div className='card full-height'>
        <div className='card-body'>
          <h5 className='card-title text-primary'>Sample Information</h5>
          <div className=' d-flex justify-content-between flex-wrap'>
            <div className='px-1'>
              <h6>Sample ID:</h6>
              <p className='mb-0'>{sample.sampleId}</p>
            </div>
            <div className='px-1'>
              <h6>Presumed Substance:</h6>
              <p className='mb-0'>
                {sample.presumedSubstance
                  ? sample.presumedSubstance === "Other" &&
                    sample.presumedSubDescription
                    ? `${sample.presumedSubstance} - ${sample.presumedSubDescription}`
                    : sample.presumedSubstance
                  : "n/a"}
              </p>
            </div>
            <div className='px-1'>
              <h6>Colour:</h6>
              <div className='mb-0'>
                {colour ? <ColourCircleC data={colour} /> : "n/a"}
              </div>
            </div>
            <div className='px-1'>
              <h6>Sample Texture:</h6>
              <div className='mb-0'>{<CardC data={texture} />}</div>
            </div>
          </div>
          <Form
            className='d-flex gap-2 mt-3 w-auto align-items-center'
            noValidate
            validated={validated}
            onSubmit={handleSave}
          >
            <Form.Label className='h6 px-1 text-nowrap mb-0'>
              Custom ID:
            </Form.Label>
            <Form.Control
              className='w-25'
              placeholder='Enter a custom ID here (max 15 characters)'
              value={customId}
              pattern='^.{0,15}$'
              isInvalid={isCustomIdInvalid}
              disabled={isSaved}
              style={{ opacity: `${isSaved ? "0.6" : ""}` }}
              onChange={(e) => setCustomId(e.target.value)}
            />
            <Form.Control.Feedback type='invalid'>
              Custom ID must be 15 characters or less.
            </Form.Control.Feedback>
            {/* if the custom ID is saved, show the edit button, else show the save button. Don't show save button if custom ID is invalid */}
            {isSaved ? (
              <Button
                variant='secondary'
                type='submit'
                onClick={(e) => {
                  e.preventDefault();
                  setIsSaved(false);
                }}
              >
                Edit
              </Button>
            ) : !isCustomIdInvalid ? (
              <Button
                variant='outline-primary'
                type='submit'
                disabled={editLoading}
              >
                {editLoading ? "Saving..." : "Save"}
              </Button>
            ) : null}
          </Form>
        </div>
      </div>
    </div>
  );
}
